import useAppSelector from "~/hooks/use-app-selector.ts";
import StatusMainPanel from "~/components/ui/status-main-panel.tsx";
import LoadingAnimation from "~/components/ui/loading-animation.tsx";
import { isOnceOffError, isOnceOffNotComplete } from "~/utils/loading.ts";
import { selectPricingModel } from "~/features/reference/selectors.ts";
import { useTranslator } from "@brickme/frontend-common/src/i18n/translation.tsx";

function PricingModelLoadStatus() {
	const load = useAppSelector(selectPricingModel);
	const t = useTranslator();

	return (
		<StatusMainPanel>
			{isOnceOffNotComplete(load) && (
				<LoadingAnimation>{t("Loading prices...")}</LoadingAnimation>
			)}
			{isOnceOffError(load) && (
				<div className="form-error">
					{t("Error loading prices:")} {load.message}
				</div>
			)}
		</StatusMainPanel>
	);
}

export default PricingModelLoadStatus;
